import { useTranslations } from 'next-intl';

import { StorePoint } from '../types';

import { styles } from './FeatureShopsPageBase.styles';
import { Map } from './Map';

interface FeatureShopsPageBaseProps {
  stores: StorePoint[];
  error?: string | null;
}

export function FeatureShopsPageBase({
  stores,
  error
}: FeatureShopsPageBaseProps) {
  const slots = styles();
  const t = useTranslations();
  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('Brand stores')}</h2>
      <div className={slots.map()}>
        {error && <div className={slots.error()}>{error}</div>}
        {!error && <Map points={stores} />}
      </div>
    </div>
  );
}
